<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
      <v-card>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center">Alert List</v-toolbar-title>
          <v-spacer></v-spacer>
          <router-link to="/Dashboard">
            <v-btn icon>
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </router-link>
          <!-- <v-card-actions class="justify-center">
            <v-btn 
              @click.stop="dialog = false"
              class="primary white--text">
              <v-icon>close</v-icon>
            </v-btn>  
          </v-card-actions> -->
        </v-toolbar>

      <!-- firm and Date filter -->
      <v-toolbar class="mb" color="white--text" flat>
        <v-layout row>
          <v-flex  xs12 md4 sm4>
            <v-autocomplete
              dense 
              flat
              clearable
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
              ></v-autocomplete>
          </v-flex>
          <v-spacer/>
          <v-flex xs12 md3 sm3>
              <v-menu
                :close-on-content-click="false"
                v-model="fromdatepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  clearable
                  slot="activator"
                  v-model="filterInvoiceFrom"
                  single-line
                  label="From Date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="filterInvoiceFrom" @input="fromdatepicker = false" />
              </v-menu>
            </v-flex>
            <v-spacer/>
            <v-flex xs12 md3 sm3>
            <v-menu
                :close-on-content-click="false"
                v-model="todatepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  clearable
                  slot="activator"
                  v-model="filterInvoiceTo"
                  label="To Date"
                  single-line
                  readonly
                ></v-text-field>
                <v-date-picker v-model="filterInvoiceTo" @input="todatepicker = false" />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-toolbar>
      <!-- End of Firm and Date Filter -->

      </v-card>

    <v-data-table
      :headers="headers"
      :items="filteredAlerts"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
          <td class="text-xs-left nowrap"><b>{{ props.item.date }}</b></td>
          <td> <b class="primary--text"> {{ props.item.buyerName }}</b></td>
          <!-- <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td> -->
          <td class="text-xs-left nowrap"><b>{{ props.item['invoiceId'] }}</b></td>
          <td class="text-xs-left nowrap"><b class="red--text font-weight-bold">{{ props.item.totalAmount || 0 | amount }}</b></td>
          <!-- <td class="text-xs-left nowrap"><b>{{ props.item.type }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.subType }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.closedDate || null }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.rate }} </b>%</td> 
          <td class="text-xs-left nowrap"><b>{{ props.item.interestValue }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.totalValue }}</b></td> -->
          <td class="text-xs-left nowrap"><b>{{ props.item.daysLeft }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.duration }}</b></td>
          <!-- <td class="text-xs-left nowrap"><b>{{ props.item.paymentType }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.status }}</b></td> -->
          <td class="text-xs-left nowrap"><b>{{ props.item.mobile }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.propName }}</b></td>
          <!-- <td class="text-xs-left nowrap"><b>{{ props.item.buyerId }}</b></td> -->
          <!-- <td class="text-xs-left nowrap"><b>{{ props.item.village }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.block }}</b></td> -->
          <td class="text-xs-left nowrap"><b>{{ props.item.tehsil }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.district }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.firmName }}</b></td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
import { compoundInterest, amountCompound } from '../../../utils/'

export default {
  name: 'AlertSheet',
  data () {
    return {
        headers: [
        { text: 'Date', sortable: true, value: 'date' },  
        { text: 'Buyer Name', sortable: true, value: 'buyerName' },
        { text: 'Invoice Id', sortable: false, value: 'invoiceId' },
        { text: 'Total Amount', sortable: false, value: 'totalAmount' },
        // { text: 'Item Type', sortable: false, value: 'itemType' },
        // { text: 'Item SubType', sortable: false, value: 'itemSubType' },
        // { text: 'Closed Date', sortable: false, value: 'closedDate' },
        // { text: 'Rate %', sortable: false, value: 'rate' },
        // { text: 'Interest Value', sortable: false, value: 'interestValue' },
        // { text: 'Total Value', sortable: false, value: 'totalValue' },
        { text: 'Days Left', sortable: true, value: 'daysLeft' },
        { text: 'Alloted Days', sortable: false, value: 'duration' },
        // { text: 'Payment Type', sortable: false, value: 'paymentType' },
        // { text: 'Status', sortable: false, value: 'status' },
        { text: 'Mobile', sortable: false, value: 'mobile' },
        { text: 'CareOf Name', sortable: false, value: 'propName' },
        // { text: 'Buyer ID', sortable: false, value: 'buyerId' },
        // { text: 'Village', sortable: false, value: 'village' },
        // { text: 'Block', sortable: false, value: 'block' },
        { text: 'Tehsil', sortable: false, value: 'tehsil' },
        { text: 'District', sortable: false, value: 'district' },
        { text: 'Firm', sortable: false, value: 'firmName' },
      ],
      firms: {},
      buyerById: {},
      sellerById: {},
      invoices: [],
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,
    }
  },
  created () {
      this.$bindAsArray(
        'invoices',
        this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear)
      )
      this.$bindAsObject(
        'buyerById',
        this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)
      )
      this.$bindAsObject(
        'sellerById',
        this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)
      )
      this.$bindAsObject(
        'firms',
        this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)
      )
      this.$bindAsArray(
        'firmList', 
        this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)
      )
  },
  computed: {
    ...mapGlobalGetters(['selectedBrand', 'finYear','brandFinYear']),
    // firmsByBrand1() {
    //   return this.firmList
    //   .filter(item => item["brand"] === this.selectedBrand)  
    // },
    
    // current brands firm list
    firmsByBrand() {
      // return selected brand firms
      let firmsB = this.firmList
        .filter((item) => item['brand'] === this.selectedBrand)
        firmsB.map((item) => {
          if (item.defaultFirm) {
            this.selectedFirm = item;
          }
        })
        return firmsB;
    },
    
    filteredAlerts() {
      if(!this.invoices) {
        return []
      }
      const alertItems = []

      this.invoices.forEach(item => {
        if((item.brand !== this.selectedBrand) && (this.selectedFirm ? item['firm'] !== this.selectedFirm['.key'] : true)) {
          return null
        }
        // if(!(item.date >= this.finYear.start) || !(item.date <= this.finYear.end)) {
        //    return null
        // }
        if(item.status === 'paid' || !item.duration) {
          return null;
        }

        // calculate value details
        const dt1 = new Date(item.date)
        const dt2 = new Date()
        const daysSpent = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24))
        
        if(item.date) {
          item.date = dt1.toLocaleDateString('en-GB')
        }
        item.closedDate = item.closedDate ? new Date(item.closedDate).toLocaleDateString('en-GB') :  null;
        const daysLeft = item.duration - daysSpent;
        
        // remove invoices which has daysLeft less than 0
        // if(daysLeft) {
        //   return null;
        // }
        if(daysLeft <= -2000 || daysLeft >= 2000) {
          return null;
        }
        // Set Item as AlertList 
        item.daysLeft = daysLeft
        item.daysSpent = daysSpent
        // item.paymentType = paymentType
        if(daysLeft && item.rate) {
          const rate = item['rate'] * 12 / 100
          let time = daysSpent / 365
          const principal = Number.parseFloat(item['totalAmount'])
          let amount = amountCompound(principal, rate, time)
          let interest = compoundInterest(principal, rate, time)
          item['interestValue'] = interest.toFixed(2)
          item['totalValue'] = amount.toFixed(2)
        }

        // set buyer info
        const buyer = this.buyerById[item.buyerId] || this.sellerById[item.buyerId] || {}
          if(buyer) {
          item.buyerName = buyer.name
          item.propName = buyer.propName
          item.village = buyer.village
          item.block = buyer.block
          item.tehsil = buyer.tehsil
          item.district = buyer.district
          item.mobile = buyer.mobile
          }
        // get items from items array
        if(item.items) {
          item.type = item.items[0].type
          item.subType = item.items[0].subType
        }

        if(item.firm) {
          const firm = this.firms[item.firm]
          item.firmName = firm && firm.name
        }
        alertItems.push(item)
      })
      return alertItems
    }
  }, 
  methods: {
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firmList.filter(item => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
  }, 
}
</script>





// WEBPACK FOOTER //
// src/components/Informations/Alertsheet/index.vue